import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MensajeService {
  private mensaje = new BehaviorSubject ('');
  constructor() { }

  setearMensaje(mensaje: string) {
    this.mensaje.next(mensaje);
  }

  limpiarMensaje() {
    this.mensaje.next('');
  }

  getMensaje(): Observable<any> {
    return this.mensaje.asObservable();
  }
}
